module.exports = __webpack_public_path__ + "assets/img/case7.8e74b136.jpg";